import React, { useCallback } from 'react';
import { IMenuTranslation, TLanguageIDs } from 'types';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface INameTranslationField {
	languageId: TLanguageIDs;
	translations: IMenuTranslation[];
	nameLabel?: string;
	changeNameTranslation?: (languageId: TLanguageIDs, value: string) => void;
}

export const NameTranslationField: React.FC<INameTranslationField> = React.memo(
	({ languageId, translations, nameLabel = 'nameLabel', changeNameTranslation }) => {
		const value = translations.find((el) => el.languageId === languageId)?.name || '';

		const handleChange = useCallback(
			(value: string) => {
				changeNameTranslation && changeNameTranslation(languageId, value);
			},
			[changeNameTranslation],
		);

		return (
			<>
				{changeNameTranslation ? (
					<OutsideFormInput
						testId="NameTranslationField"
						name="name"
						label={nameLabel}
						errorMessage="enterTranslation"
						maxLength={100}
						value={value}
						onChange={handleChange}
					/>
				) : (
					<FullInfoField label={nameLabel} value={value || '-'} />
				)}
			</>
		);
	},
);
